import React from 'react';

export const useRefresh = (): [refresh: boolean, startRefreshing: () => void] => {
  const [refreshing, setRefreshing] = React.useState(false);
  React.useEffect(() => {
    if (refreshing) {
      setRefreshing(false);
    }
  }, [refreshing]);
  return [refreshing, (): void => setRefreshing(true)];
};
